import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from 'utils/util';
import CmsPreviewShell from "./CmsPreviewShell";


const formatDateRange = (start, end) => {
  const s = start.slice(5).replace("-", "/");
  const e = end.slice(5).replace("-", "/");
  return `${s} ~ ${e}`;
};


const remainingLabel = (capacity, booked) => {
  const left = Math.max(capacity - booked, 0);
  if (left === 0) return { text: "마감", urgent: true };
  if (left <= 2) return { text: `마감임박 ${left}석`, urgent: true };
  return { text: `잔여 ${left}석`, urgent: false };
};

const TourComponent = ({ title, subtitle, layout, items = [] }) => {
  const navigate = useNavigate();
  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-tour cms-tour--${layout}`}>
        {items.map((item) => {
          const left = remainingLabel(item.capacity, item.booked_count);
          return (
            <div key={item.id} className="cms-tour__item"  onClick={()=>{linkOpen(item.link.replace('tours','tour/detail'), navigate)}}>
              <div className="cms-tour__image">
                {item.img ? (
                  <img src={item.img} alt={item.title} />
                ) : (
                  <div className="cms-tour__placeholder">이미지 없음</div>
                )}
                <span
                  className={`cms-tour__remaining${left.urgent ? " cms-tour__remaining--urgent" : ""}`}
                >
                  {left.text}
                </span>
              </div>
              <div className="cms-tour__body">
                <h5 className="cms-tour__title">{item.title}</h5>
                {item.region && <span className="cms-tour__region">📍 {item.region}</span>}
                {item.start_date && item.end_date && (
                  <span className="cms-tour__date">
                    {formatDateRange(item.start_date, item.end_date)}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default TourComponent;
